import { get, includes } from 'lodash-es'
import VueI8n from '@/i18n/locale'
const INVALID_REASON = { // 商机无效原因
  DUPLICATE: 7, // 重复门店
  ELSE: 999 // 其他原因
}
export default {
  required (mask = '', { gettext }, payload) {
    return {
      messages: { required: `${mask} ${gettext('不能为空')}` },
      rules: { required: true }
    }
  },

  max (mask = '', { gettext, sprintf }, payload) {
    const [max] = payload
    return {
      messages: { max: `${mask}${sprintf(gettext('不能超过%d'), max)}` },
      rules: { max: +max, type: 'number' }
    }
  },

  min (mask = '', { gettext, sprintf }, payload) {
    const [min] = payload
    return {
      messages: { min: `${mask}${sprintf(gettext('不小于%d'), min)}` },
      rules: { min: +min, type: 'number' }
    }
  },

  maxLength (mask = '', { gettext, sprintf }, payload) {
    const [length] = payload
    return {
      messages: { max: `${mask}${sprintf(gettext('不能超过%d字'), length)}` },
      rules: { max: +length }
    }
  },

  requireLength (mask = '', { gettext, sprintf }, payload) {
    const [length] = payload
    return {
      messages: { len: `${mask}${sprintf(gettext('必须为%d字'), length)}` },
      rules: {
        len: length
      }
    }
  },

  requireMultyLength (mask = '', { gettext, sprintf }, payload) {
    const [length1, length2] = payload
    return {
      messages: { custom: `${mask}${sprintf(gettext('必须为%d或%d字'), length1, length2)}` },
      rules: {
        custom: (value) => {
          let length = value.trim().length
          if (length === length1 || length === length2) {
            return true
          } else {
            return false
          }
        }
      }
    }
  },
  /**
   * 大阪固话：共10位
   * 06+8位
   * 072+7位
   * 全国手机：共11位
   * 070+8位
   * 080+8位
   * 090+8位
   */
  multiplePhones (mask = '', { gettext, sprintf }, payload) {
    const [max] = payload
    return {
      rules: {
        custom: value => (value && max ? value.split(',').length <= max : true),
        // 固话规则0 +9位数字/10位数字（该规则比较宽泛包含手机号校验规则）
        pattern: /^(0\d{9}\d?,*)+$/
      },
      messages: {
        custom: max ? `${mask}${sprintf(gettext('最多%d个'), max)}` : '',
        pattern: gettext('电话支持字符：数字、英文逗号，录入其他符号，不允许提交')
      }
    }
  },

  // 结构化多个电话
  structuredPhones (mask = '', { gettext, sprintf }, payload) {
    const validator = function (value) {
      for (let i of value) {
        if (!/^[0-9]{10}$/.test(i.value)) {
          return false
        }
      }
      return true
    }
    return {
      rules: {
        custom: validator
      },
      messages: {
        custom: gettext('手机和座机都只支持10位数字')
      }
    }
  },

  postCode (mask = '', { gettext }, payload) {
    return {
      rules: {
        pattern: /^\d{3}-\d{4}$/
      },
      messages: {
        pattern: `${mask}${gettext('输入有误')}`
      }
    }
  },

  phone (mask = '', { gettext }, payload) {
    return {
      messages: {
        pattern: `${mask}${gettext('仅支持数字输入')}`
      },
      rules: {
        pattern: /^(06\d{1}|072)\d{7}$/
      }
    }
  },

  telePhone (mask = '', { gettext }, payload) {
    return {
      messages: {
        pattern: `${mask}${gettext('输入有误')}`
      },
      rules: {
        // 050 070 080 090 + 8位数字
        pattern: /^0[57-9]0\d{8}$/
      }
    }
  },

  email (mask = '', { gettext }, payload) {
    return {
      rules: {
        // 和后端规则保持一致
        pattern: /^[^@]+@[^@]+$/i
        // type: 'email'
      },
      messages: {
        pattern: gettext('请输入正确的邮箱地址')
      }
    }
  },

  number (mask = '', { gettext }, payload) {
    return {
      rules: {
        type: 'number'
      },
      messages: {
        type: gettext('请输入数字')
      }
    }
  },
  // 商户号12位数字的校验
  registerId (mask = '', { gettext }, payload) {
    return {
      rules: {
        pattern: /^\d{12}$/
      },
      messages: {
        pattern: gettext('请输入12位有效数字')
      }
    }
  },
  accountCardno (mask = '', { gettext }, payload) {
    return {
      rules: {
        pattern: /^\d{7}$/
      },
      messages: {
        pattern: gettext('请输入7位有效数字')
      }
    }
  },
  accountBankBranchNo (mask = '', { gettext }, payload) {
    return {
      rules: {
        pattern: /^\d{3}$/
      },
      messages: {
        pattern: gettext('请输入3位有效数字')
      }
    }
  },
  requiredSelect (mask = '', { gettext }, payload) {
    return {
      rules: {
        custom: value => {
          // if (!value) return true
          /* eslint-disable */
          return !(value === 0)
        }
      },
      messages: {
        custom: mask + ' ' + gettext('不能为空')
      }
    }
  },
  cardNumber (mask = '', { gettext }, payload) {
    return {
      rules: {
        type: 'number',
        len: 18
      },
      messages: {
        type: gettext('银行卡号仅支持数字输入'),
        len: gettext('银行卡号必须为18位')
      }
    }
  },

  specialChars (mask = '', { gettext }, payload) {
    return {
      rules: {
        custom: value => {
          if (!value) return true
          /* eslint-disable */
          return !/[\!\"\#\$\%\/\(\)\=\?\¡\¨\*\[\]\;\:\_\¿\´\+\{\}\,\.\-\>\<\°\|\@\¬\\\~\`\^\ñ\Ñ\á\é\í\ó\ú\Á\É\Í\Ó\Ú\â\ê\î\ô\û\Â\Ê\Î\Ô\Û\ä\ë\ï\ö\ü\Ä\Ë\Ï\Ö\Ü]+/.test(
            value
          )
        }
      },
      messages: {
        custom: gettext('不允许特殊字符')
      }
    }
  },
  // 税号13位数字的校验
  taxId(mask = '', { gettext }){
    return {
      rules: {
        pattern: /^\d{13}$/
      },
      messages: {
        pattern: gettext('请输入13位有效数字')
      }
    }
  },
  
  curpRules(mask = '', { gettext }) {
    return {
      rules: {
        len: 18,
        custom: value => (value ? /^(\d{3})\.(\d{0,3})\.(\d{0,3})\-(\d{0,2})/.test(value) : true)
      },
      messages: {
        custom: gettext('Curp号必须为大写字母'),
        len: gettext('Curp号必须为18位字符')
      }
    }
  },

  cpfRules (mask = '', { gettext }) {
    return {
      rules: {
        // len: 14,
        custom: value => {
          if (!value) return true
          if (value.length !== 14) return false
          return (value.length === 14 ? /^(\d{3})\.(\d{0,3})\.(\d{0,3})\-(\d{0,2})$/.test(value) : true)
        }
      },
      messages: {
        custom: gettext('CPF号必须为11位数字'),
        // len: gettext('CPF号必须为11位数字')
      }
    }
  },

  cnpjRules (mask = '', { gettext }) {
    return {
      rules: {
        // len: 18,
        custom: value => {
          if (!value) return true
          if (value.length !== 18) return false
          return (value.length === 18 ? /^(\d{2})\.(\d{0,3})\.(\d{0,3})\/(\d{0,4})\-(\d{0,2})$/.test(value) : true)
        }
      },
      messages: {
        custom: gettext('CNPJ号必须为14位数字'),
        // len: gettext('CNPJ号必须为18位数字')
      }
    }
  },

  decimal(mask, { gettext, sprintf }, payload) {
    const [len] = payload
    return {
      rules: {
        type: 'number',
        custom: value => {
          let decimal = (value + '').split('.')[1]
          return decimal ? decimal.length <= len : true
        }
      },
      messages: {
        custom: sprintf(mask + gettext('数值只能是%s位小数'), len)
      }
    }
  },

  openInfo (mask = '', { gettext }, payload) {
    const [tip1] = payload
    return {
      rules: {
        custom: value => {
          if (!value) return true          
          /* eslint-disable */
          return value.isNeedPad !== 0
        }
      },
      messages: {
        custom: `${mask}/${tip1}${gettext('不能为空')}`
      }
    }
  },
  cost (mask = '', { gettext, sprintf }, payload) {
    const [max] = payload
    return {
      rules: {
        type: 'number',
        custom: value => {
          return value ? value <= max : true
        }
      },
      messages: {
        custom: sprintf(mask + gettext('不能超过%d'), max)
      }
    }
  },
  // 扣费次数，正整数校验
  startupCostNum(mask = '', { gettext, sprintf }, payload){
    return {
      rules: {
        pattern: /^[0-9]*$/
      },
      messages: {
        pattern: gettext('格式错误')
      }
    }
  },
  halfWidthKatakana (mask = '', { gettext, sprintf }, payload) {
    return {
      rules: {
        custom: value => {
          if (!value) return true
          /* eslint-disable */
          if (/^[ｦ-ﾟ0-9A-Z]*$/.test(value) && /^[^ｨｬｭｮｬｭ]*$/.test(value)) return true
        }
      },
      messages: {
        custom: gettext('请输入半角片假名')
      }
    }
  },
  accountLastName (mask = '', { gettext, sprintf }, payload) {
    return {
      rules: {
        custom: value => {
          if (!value) return true
          /* eslint-disable */
          if (value.length >= 48) return false
          if (/^(([ｦ-ﾟ0-9A-Z])|( |\.|,|\(|\)|-|\/))*$/g.test(value) && /^[^ｨｬｭｮｬｭ]*$/.test(value)) return true
        }
      },
      messages: {
        custom: gettext('请输入半角片假，不能超过48个字符')
      }
    }
  },
  shopId (mask = '', { gettext, sprintf }, payload) {
    return {
      rules: {
        custom: value => {
          return true
        },
        customRequired: value => {
          if (!value) { return false }
          if (!get(value, 'list.length', null)) { return false }
          return true
        },
        repeatShopId: value => {
          if (includes(value.list, INVALID_REASON.DUPLICATE) && !value.repeatShopId) { 
            return false
          }
          if (includes(value.list, INVALID_REASON.DUPLICATE) && !(/^[0-9]+$/.test(value.repeatShopId))) {
            return false
          }
          return true
        }
      },
      messages: {
        custom: gettext('您提交的无效原因有误，请检查'),
        customRequired: `${mask}${gettext('不能为空')}`,
        repeatShopId: gettext('请输入有效的门店id')
      }
    }
  },
  requireValue (mask = '', { gettext }, payload) {
    const [requireValue] = payload
    return {
      rules: {
        custom: value => {
          return value === requireValue
        }
      },
      messages: {
        custom: `${mask}${gettext('需要完善')}`
      }
    }
  },
  shopIdCascade (mask = '', { gettext }) {
    return {
      rules: {
        custom: value => {
          return !!value
        },
        repeatShopId: value => {
          return !!(/^[0-9]+$/.test(value))
        }
      },
      messages: {
        custom: `${mask}${gettext('不能为空')}`,
        repeatShopId: gettext('请输入有效的门店id')
      }
    }
  }
}
